module.exports = __webpack_public_path__ + "img/horizontal_3_7_9005.7ce5078b.png";